export enum Consent {
  Analytics = 'analytics',
  Marketing = 'marketing',
}
